import { TelemetryType, type TrackDto } from '../api/apiTypes'
import { isEmptyGuid } from '../utils/guidUtils'

export const PROCESSING_TELEMETRY_TYPES: readonly TelemetryType[] =
  Object.freeze([
    TelemetryType.Gps,
    TelemetryType.Accelerometer,
    TelemetryType.Gyroscope,
    TelemetryType.Device,
  ])

export function unknownTrackDto(trackId: string): TrackDto {
  return {
    id: trackId,
    name: 'Unknown',
    finishLine: [],
    countryCode: 'UN',
    isUserSuggested: false,
  }
}

export function trackToProcessWith(
  trackId: string,
  track: TrackDto | null
): TrackDto | null {
  if (track) return track
  return isEmptyGuid(trackId) ? unknownTrackDto(trackId) : null
}
